<div class="mt-4">
  <ol class="breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" disabled>Commandes</button></li>
  </ol>
</div>


<div class="my-3 p-3 bg-white rounded shadow-sm">
  <div class="input-group mb-4">
    <div class="input-group-prepend">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
    </div>
    <input type="text" class="form-control" placeholder="Recherche" [(ngModel)]="searchRequest.query" (keyup)="querySearch()"/>

    <rma-supplier-search-criteria class="input-group-append"></rma-supplier-search-criteria>

    <button class="ml-3 btn btn-outline-primary" (click)="openSearchSupplierModal()">Nouveau retour</button>
  </div>

  <div class="btn-toolbar">
    <div class="input-group pr-2 pb-2" *ngIf="searchRequest.getValues('supplier').length > 0">
      <div class="input-group-prepend">
        <div class="btn btn-secondary btn-sm">{{ displaySupplierFilter() }}</div>
      </div>
      <div class="input-group-append">
        <button class="btn btn-secondary btn-sm" type="button" (click)="clearSupplier()" >X</button>
      </div>
    </div>
  </div>

  <div class="border-bottom"></div>
  
  <search-paging [searchComponent]="this"></search-paging>

  <div *ngIf="results" >
    <div class="container-fluid text-center"*ngFor="let rma of results.content">
      <div class="d-flex p-3 mb-3 bg-light rounded shadow-sm row">
        <h5 class="col-xl">{{ rma.supplier.name }}</h5>
        <div class="col-xl">Retour {{ rma.number }}</div>
        <div class="col-xl">{{ rma.references }} référence(s)</div>
        <div class="col-xl p-2">
          <rma-status [status]="rma.status"></rma-status>
        </div>
        <div class="col-xl-4">
          <div>Ouvert le <strong>{{ rma.creationTimestamp | date: 'medium' }}</strong></div>
          <div *ngIf="rma.confirmTimestamp">Confirmé par le fournisseur <strong>{{ rma.confirmTimestamp | date: 'medium' }}</strong></div>
          <div *ngIf="rma.cancelTimestamp">Annulé le <strong>{{ rma.cancelTimestamp | date: 'medium' }}</strong></div>
        </div>
        <div class="col-xl">
          <button class="btn btn-sm btn-outline-primary m-2" (click)="openRma(rma)"><span class="bi bi-file-text"></span></button>
        </div>
      </div>
    </div>
  </div>

  <search-paging [searchComponent]="this"></search-paging>
</div>